import axios from "axios";

export default axios.create({
  baseURL: window.AUTH_API,
  withCredentials: true
});
